module.exports = new __parcel__URL__("soleil-nuage-2.7b675de9.svg").toString();